import {
  Box,
  ExpandableSection,
  TableProps,
} from "@amzn/awsui-components-console";
import React from "react";

import { NoMediaEntry } from "@/hooks/cart/useGroupedPlayAssets";

import ChatMarkdownTable from "../chat/ChatMarkdownTable";

export interface NoMediaCardProps {
  entries: NoMediaEntry[];
}

const columnDefinitions: TableProps["columnDefinitions"] = [
  {
    id: "gameId",
    header: "Game ID",
    cell: (entry: NoMediaEntry) => entry.gameId,
  },
  {
    id: "playId",
    header: "Play ID",
    cell: (entry: NoMediaEntry) => entry.playId,
  },
  {
    id: "playDescription",
    header: "Play Description",
    // The play has no media; its description comes from the agent's answer
    // (play-by-play), carried on the entry. Falls back to a muted placeholder.
    cell: (entry: NoMediaEntry) =>
      entry.description ? (
        entry.description
      ) : (
        <Box color="text-status-inactive">—</Box>
      ),
  },
];

/**
 * A single collapsed card grouping every play that returned no media. Instead
 * of one empty accordion per play, the no-media plays are listed in one table
 * (Game ID, Play ID, Play Description) styled like the asset accordions, kept
 * below the accordions that do have media.
 */
const NoMediaCard: React.FC<NoMediaCardProps> = ({ entries }) => (
  <ExpandableSection
    variant="container"
    headerText="No Media Found"
    headerCounter={`(${entries.length})`}
  >
    <ChatMarkdownTable
      columnDefinitions={columnDefinitions}
      items={entries}
      wrapLines={false}
    />
  </ExpandableSection>
);

export default NoMediaCard;
